import { Box, Typography } from "@mui/material";
import React from "react";
import "./PublicPages.css";

const TermsAndConditionsPublic = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        padding: { xs: "20px", sm: "40px", md: "60px" },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          margin: "0 auto",
          bgcolor: "#fff",
          padding: { xs: "20px", sm: "40px" },
          borderRadius: "8px",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "24px", sm: "32px" },
            fontWeight: "600",
            marginBottom: "30px",
            color: "#0C2C50",
          }}
        >
          Terms and Conditions
        </Typography>

        <Box
          className="public-page-content"
          sx={{
            "& p": {
              marginBottom: "16px",
              lineHeight: "1.6",
              color: "#333",
            },
            "& h1, & h2, & h3, & h4, & h5, & h6": {
              marginTop: "24px",
              marginBottom: "16px",
              color: "#0C2C50",
            },
            "& ul, & ol": {
              marginBottom: "16px",
              paddingLeft: "24px",
            },
            "& li": {
              marginBottom: "8px",
            },
          }}
        >
          <p>
            <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
          </p>
          
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using FIDDUX services, you accept and agree to be bound by 
            the terms and provision of this agreement. If you do not agree to these terms, 
            you should not use our services.
          </p>

          <h2>2. Description of Service</h2>
          <p>
            FIDDUX provides technological solutions to establish an infrastructure conducive 
            to a New Economy of Value. We offer investment management and financial services 
            through our encrypted and decentralized platform.
          </p>

          <h2>3. Account Registration</h2>
          <p>To use our services, you must:</p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Maintain the security of your account credentials</li>
            <li>Notify us immediately of any unauthorized use</li>
            <li>Be at least 18 years of age</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>

          <h2>4. Investment Risks</h2>
          <p>
            <strong>IMPORTANT:</strong> All investments carry risk. The value of investments 
            can go down as well as up, and you may not get back the amount you invested. 
            Past performance is not indicative of future results. You should only invest 
            what you can afford to lose.
          </p>

          <h2>5. Deposits and Withdrawals</h2>
          <ul>
            <li>Deposits are subject to verification and approval</li>
            <li>Withdrawals may be subject to processing times and fees</li>
            <li>We reserve the right to request additional documentation for security purposes</li>
            <li>Large withdrawals may require additional verification</li>
          </ul>

          <h2>6. Fees and Charges</h2>
          <p>
            Our fee structure is disclosed in your account documentation. Fees may be 
            charged for certain transactions, account maintenance, or services. All fees 
            will be clearly communicated before you incur them.
          </p>

          <h2>7. Prohibited Activities</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Interfere with or disrupt the service</li>
            <li>Use automated systems to access the service without permission</li>
            <li>Share your account credentials with others</li>
          </ul>

          <h2>8. Intellectual Property</h2>
          <p>
            All content, features, and functionality of the FIDDUX platform are owned by 
            FIDDUX and are protected by international copyright, trademark, and other 
            intellectual property laws.
          </p>

          <h2>9. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, FIDDUX shall not be liable for any 
            indirect, incidental, special, consequential, or punitive damages, or any 
            loss of profits or revenues, whether incurred directly or indirectly.
          </p>

          <h2>10. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at any time, with 
            or without notice, for any reason, including violation of these Terms and 
            Conditions or suspected fraudulent activity.
          </p>

          <h2>11. Governing Law</h2>
          <p>
            These Terms and Conditions shall be governed by and construed in accordance 
            with the laws of Estonia, without regard to its conflict of law provisions.
          </p>

          <h2>12. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms and Conditions at any time. 
            Changes will be effective immediately upon posting. Your continued use of 
            the service after changes are posted constitutes acceptance of the modified terms.
          </p>

          <h2>13. Contact Information</h2>
          <p>
            If you have any questions about these Terms and Conditions, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:order@fiddux.com" style={{ color: "#0C2C50" }}>order@fiddux.com</a><br />
            <strong>Address:</strong> Joe 2, Harjumaa, 10151, Tallinn, Estonia
          </p>
        </Box>

        <Box
          sx={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "#666" }}>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", marginTop: "8px" }}>
            For questions, contact:{" "}
            <a
              href="mailto:order@fiddux.com"
              style={{ color: "#0C2C50", textDecoration: "none" }}
            >
              order@fiddux.com
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TermsAndConditionsPublic;
